import React from 'react';

import { css } from '@emotion/react';
import { colors, Primitive, Skeleton, useTheme } from '@rtkwlf/fenrir-react';

export const NavigationItemSkeleton: React.FC = () => {
  const theme = useTheme();
  const isDarkMode = theme?.themeMode === 'dark';

  const skeletonBackground = isDarkMode
    ? colors.background.brand.tertiary
    : colors.background.brand.secondary;

  const skeletonBackgroundOpacity = isDarkMode ? '0.25' : '1';

  return (
    <Primitive.div marginBottom="smedium">
      <Skeleton
        width="8rem"
        css={css({
          '&::after': {
            background: `linear-gradient(90deg, transparent, rgba(${colors.mono.white}, 0.1), transparent)`,
          },
          background: `rgba(${skeletonBackground}, ${skeletonBackgroundOpacity})`,
        })}
      />
    </Primitive.div>
  );
};
